import { showCartErrorMessage } from 'features/cart/desktop';
import { trackCartActions } from 'features/cart';
import { setProductCheckout } from 'features/tealium';
import { setProductCheckout as setProductCheckoutGa4 } from 'features/tealium/ga4/ecommerce';
import { setButtonStateDuringActivity } from 'utilities/dom';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import { cart } from '../config';
import CartBaseItemView from '../../baseViews/ItemView';
import CheckoutNowButtonTemplate from '../templates/CheckoutNowButtonTemplate';

const checkOutNowSelector = '.checkOutNow';

const CheckoutNowButton = CartBaseItemView.extend({
	JSXTemplate: CheckoutNowButtonTemplate,
	ui: {
		checkOutNow: checkOutNowSelector
	},
	events: {
		'click @ui.checkOutNow': 'proceedToShipping'
	},
	initialize () {

		this.listenTo(this.model, 'change', () => {

			this.render();

		});

	},
	proceedToShipping (e) {

		e.preventDefault();

		const ui = $(e.target);

		const proceedToShippingPromises = [];

		trackCartActions({
			event_action: 'click-Check-Out-Now'
		});

		setGenericEvent({ event_name: 'cart_check_out_now_click' });
		if (ui.attr('aria-disabled') === 'true') {

			return false;

		}

		// verify gift card fields filled up for each item
		const incompleteGiftCardFields = function (element) {

			const giftCardProductInfo = element.GiftCardProductInfo;

			if (!giftCardProductInfo || element.IsPickUpInStore) {

				return false;

			}

			const giftCardType = giftCardProductInfo.GiftCardType;
			const firstName = giftCardProductInfo.RecipientFirstName?.trim() || '';
			const lastName = giftCardProductInfo.RecipientLastName?.trim() || '';
			const email = giftCardProductInfo.RecipientEmail?.trim() || '';
			const isFullNameMissing = firstName === '' && lastName === '';

			return (
				([ 1, 4 ].includes(giftCardType) && isFullNameMissing && email === '')
				|| (giftCardType === 2 && isFullNameMissing)
			);

		};

		if (this.model.get('ProductItems').some(incompleteGiftCardFields)) {

			showCartErrorMessage({
				cartStatus: 'Please fill out the required gift card fields.',
				response: ''
			});
			const promise = new $.Deferred();
			promise.reject();
			proceedToShippingPromises.push(promise);

		}

		// Trigger proceedToShipping event with extra parameter proceedToShippingPromises
		// validators will push their promises
		$(cart).trigger('proceedToShipping', [ proceedToShippingPromises ]);

		// When (and if) all promises resolve, proceed to Shipping page
		$.when.apply(null, proceedToShippingPromises).done(() => this.redirectToShippingPage());

		if (proceedToShippingPromises.scrollToElement) {

			$('html, body').animate(
				{
					scrollTop: proceedToShippingPromises.scrollToElement.offset().top
				},
				250
			);

		}

		return false;

	},
	redirectToShippingPage () {

		// fire checkout step1 event for Google Analytics
		setProductCheckout('product_checkout_step_1', 'product checkout step 1');
		setProductCheckoutGa4('begin_checkout');

		setButtonStateDuringActivity(this.ui.checkOutNow[0]);

		window.location.href = cart.urlCheckOutNow;

	}
});

export default CheckoutNowButton;
